import { useContext, useEffect } from 'react';
import { ErrorModalIcon } from '../../../../../assets/icons';
import { CollapsibleAreaContext } from '../../../../../components/CollapsibleArea';
import Loading from '../../../../../components/Loading';
import { TabsContext } from '../../../../../components/Tabs';
import { RiskModelType } from '../../../../../context/createASpool/createASpoolType';
import { formatAmountWithSuffix } from '../../../../../helpers/formats';
import useIsMounted from '../../../../../hooks/useIsMounted';
import useSpoolsByRiskModel from '../../../../../hooks/web3/app/useSpoolsByRiskModel';

type Props = {
    riskModel: RiskModelType;
};

const SpoolsByRiskModelTable: React.FC<Props> = ({ riskModel }) => {
    const { updateCollapsedHeight } = useContext(CollapsibleAreaContext);

    const { updateHeight } = useContext(TabsContext);

    const { address } = riskModel;

    const { spoolsByRiskModel, isLoading } = useSpoolsByRiskModel(address);

    const isMounted = useIsMounted();

    useEffect(() => {
        updateHeight();
        const interval = setInterval(() => {
            if (isMounted()) {
                updateCollapsedHeight();
            }
        }, 100);

        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 600);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [isLoading, isMounted, updateCollapsedHeight, updateHeight]);

    return (
        <>
            <Loading isLoading={isLoading} text='Loading Spools...'>
                {spoolsByRiskModel ? (
                    spoolsByRiskModel.length ? (
                        <>
                            <div className='spool title'>
                                <span>Spool Name</span>
                                <span>TVR</span>
                            </div>
                            <div className='spool title'>
                                <span>Spool Name</span>
                                <span>TVR</span>
                            </div>
                            {spoolsByRiskModel.map(({ name, tvr }, index) => (
                                <div className='spool' key={index}>
                                    <span className='spool-name'>{name}</span>
                                    <span className='tvr'>
                                        {tvr === '0'
                                            ? 'N/A'
                                            : `$${formatAmountWithSuffix(tvr)}`}
                                    </span>
                                </div>
                            ))}
                        </>
                    ) : (
                        <div className='error'>
                            <ErrorModalIcon />
                            No Spools currently use this Risk Model.
                        </div>
                    )
                ) : (
                    <div className='error'>
                        <ErrorModalIcon />
                        An unexpected error occurred while loading Spools.
                    </div>
                )}
            </Loading>
        </>
    );
};

export default SpoolsByRiskModelTable;
